import { $api } from '../y/api';
import { $http } from '../y/http';
import { YId, YTimeString } from '../y/types';
import { TSeat, TTicket } from './t-ticket';

export interface TPdfFailure {
    id: YId;
    name: string;
    object_id?: YId;
    pages: string[];
    hash: string;
    is_fixed: boolean;
    created_at: YTimeString;
}

export type TPdfSpecField = 'event_name' | 'session' | 'seat' | 'entrance' | 'row' | 'section';
export type TPdfSpecFlag = 'merge_entrance'

export interface TPdfSpec {
    id: YId;
    name: string;
    regex: string;
    mapping: { [key in TPdfSpecField]?: number };
    flags: { [key in TPdfSpecFlag]?: boolean };
    used_count: number;
    created_at: YTimeString;
    last_used_at?: YTimeString;
}

export function tPdfFailuresGetAll() {
    return $http.GET<TPdfFailure[]>('/service/ticket/v1/pdf/failures').catch($api.errorHandler);
}

export function tPdfFailureGet(id: YId) {
    return $http.GET<TPdfFailure>(`/service/ticket/v1/pdf/failure/${id}`).catch($api.errorHandler);
}

interface tPdfFailureTestResponse {
    seats: TSeat[];
    title: string;
}

export function tPdfFailureTest(id: YId, spec: any) {
    return $http.POST<tPdfFailureTestResponse>(`/service/ticket/v1/pdf/failure/${id}/test`, spec).catch($api.errorHandler);
}

export function tPdfFailureDelete(id: YId) {
    return $http.DELETE<TPdfFailure[]>(`/service/ticket/v1/pdf/failure/${id}`).catch($api.errorHandler);
}

export function tPdfSpecsGetAll() {
    return $http.GET<TPdfSpec[]>('/service/ticket/v1/pdf/specs').catch($api.errorHandler);
}

export function tPdfSpecCreate(spec: any) {
    return $http.POST<TPdfSpec>('/service/ticket/v1/pdf/spec', spec).catch($api.errorHandler);
}

export function tPdfSpecDelete(id: YId) {
    return $http.DELETE(`/service/ticket/v1/pdf/spec/${id}`).catch($api.errorHandler);
}

export type TPdfRecognitionType = 'regex' | 'gemini' | 'unnumbered';

export interface TPdfRecognizeResponse {
    tickets: TTicket[];
    seats: TSeat[];
    scheduled?: YTimeString;
    spec?: TPdfSpec;
}

export function tPdfRecognize(file: File, method: TPdfRecognitionType, session: YId | undefined, assign: boolean, progress?: (p: number) => void) {
    return $http.POST<{ task: string }>(`/service/ticket/v1/pdf/recognize`, file, { aux: { method, name: encodeURIComponent(file.name), session, assign }, up_progress: progress }).catch($api.errorHandler);
}

